import React from 'react';
import { Box } from '@mui/material';
import LabMarkdown from 'components/collab/lab/LabMarkdown';

/**
 * Call texts are Markdown since the sync converts funder HTML (lists, bold, headings, links).
 * Older calls hold plain text with one line per paragraph and "• " bullets; turn those into
 * Markdown too, so both render the same way.
 */
export function asMarkdown(text = '') {
  return text
    .replace(/\r\n?/g, '\n')
    .replace(/^[ \t]*[•▪◦·][ \t]*/gm, '- ')
    // a single line break ends a paragraph, unless the next line is a list item or the break is a hard break
    .replace(/([^\n])(?<! {2})\n(?![\n \t]*(?:[-*+]|\d+\.)[ \t])(?!\n)/g, '$1\n\n')
    // a list needs a blank line before it when it follows a paragraph
    .replace(/^(?![ \t]*(?:[-*+]|\d+\.)[ \t]).+\n(?=[ \t]*(?:[-*+]|\d+\.)[ \t])/gm, '$&\n');
}

const SECTION = /^[ \t]*(?:#{1,6}[ \t]*)?(?:\*\*)?[ \t]*(?:Expected[ \t]+Outcomes?|Scope)[ \t]*:?[ \t]*(?:\*\*)?[ \t]*$/im;

/** The description without the Expected Outcome / Scope sections that the page shows separately. */
export function introOnly(description = '', call = {}) {
  if (!description || !(call.expected_outcomes || call.scope)) return description || '';
  const m = description.match(SECTION);
  return m ? description.slice(0, m.index).trim() : description;
}

/** A call text section rendered as Markdown, in the page's secondary text colour. */
export default function CallText({ children, sx }) {
  if (!children) return null;
  return (
    <Box sx={{ color: 'text.secondary', '& .MuiTypography-root:not(a)': { color: 'inherit' }, ...sx }}>
      <LabMarkdown>{asMarkdown(children)}</LabMarkdown>
    </Box>
  );
}
